<template>
  <pt-feedback-manage class="pt-feedback-manage__page"></pt-feedback-manage>
</template>

<script>
import PtFeedbackManage from 'cps/other-service/pt-feedback-manage/withData'
export default {
  name: 'pt-feedback-manage__view',
  components: {
    'pt-feedback-manage': PtFeedbackManage
  }
}
</script>
